import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import { Tooltip } from '@src/components/Tooltip';
import FrUserSearchSvg from '@src/svgs/fr-user-search.svg';
import { Props } from './props';

export const View: FC<Props> = ({ isUserVerified }) => {
  if (isUserVerified) {
    return (
      <div className={'talent-feed-item-actions__item'}>
        <Svg className="talent-feed-item-actions__icon" src={FrUserSearchSvg} />
        <span>View</span>
      </div>
    );
  }

  return (
    <Tooltip placement="top" overlay={<span>Talent has hidden their profile.</span>}>
      <div className="talent-feed-item-actions__item talent-feed-item-actions__item--disabled">
        <Svg className="talent-feed-item-actions__icon" src={FrUserSearchSvg} />
        <span>View</span>
      </div>
    </Tooltip>
  );
};
